/*
 * permisos.js — Solicitudes de acceso a meses pasados (C-028).
 *
 * Lógica pura de la franja que ve el contador arriba de la tabla y de los textos con hora.
 * La hora siempre se escribe completa ("mañana 14 oct, 11:32"), nunca "24 h".
 */

const MESES_CORTOS = ['ene', 'feb', 'mar', 'abr', 'may', 'jun', 'jul', 'ago', 'sep', 'oct', 'nov', 'dic'];
const MESES = ['enero', 'febrero', 'marzo', 'abril', 'mayo', 'junio', 'julio', 'agosto', 'septiembre', 'octubre', 'noviembre', 'diciembre'];

const inicioDelDia = (d) => new Date(d.getFullYear(), d.getMonth(), d.getDate());
const hora = (d) => `${String(d.getHours()).padStart(2, '0')}:${String(d.getMinutes()).padStart(2, '0')}`;

/** "julio 2026" a partir del mes 0-11. */
export const nombreMesPermiso = (mes, anio) => `${MESES[mes]} ${anio}`;

/** "hoy 11:32", "mañana 14 oct, 11:32", "ayer 13 oct, 09:05" o "2 oct, 11:32". */
export function fechaHora(fecha, ahora = new Date()) {
  if (!fecha) return '';
  const d = fecha instanceof Date ? fecha : new Date(fecha);
  if (Number.isNaN(d.getTime())) return '';
  const dias = Math.round((inicioDelDia(d) - inicioDelDia(ahora)) / 86400000);
  const dia = `${d.getDate()} ${MESES_CORTOS[d.getMonth()]}${d.getFullYear() !== ahora.getFullYear() ? ` ${d.getFullYear()}` : ''}`;
  if (dias === 0) return `hoy ${hora(d)}`;
  if (dias === 1) return `mañana ${dia}, ${hora(d)}`;
  if (dias === -1) return `ayer ${dia}, ${hora(d)}`;
  return `${dia}, ${hora(d)}`;
}

/** Minutos que faltan para que venza un acceso (0 si ya venció). */
export const minutosRestantes = (fechaExpiracion, ahora = new Date()) =>
  Math.max(0, Math.ceil((new Date(fechaExpiracion) - ahora) / 60000));

/**
 * Qué franja ve el contador en un mes pasado, según su solicitud:
 *   'lectura'    sin solicitud (o cancelada): solo lectura, [Pedir acceso…]
 *   'pendiente'  esperando respuesta, [Cancelar solicitud]
 *   'acceso'     aprobada y vigente
 *   'por-vencer' aprobada y le queda una hora o menos
 *   'vencida'    venció o se la quitaron, [Pedir acceso otra vez…]
 *   'rechazada'  no se aprobó, con la nota si la hay, [Pedir acceso otra vez…]
 */
export function estadoFranja(solicitud, ahora = new Date()) {
  if (!solicitud || solicitud.estado === 'cancelado') return 'lectura';
  if (solicitud.estado === 'pendiente') return 'pendiente';
  if (solicitud.estado === 'rechazado') return 'rechazada';
  if (solicitud.estado === 'aprobado') {
    const minutos = minutosRestantes(solicitud.fecha_expiracion, ahora);
    if (minutos <= 0) return 'vencida';
    return minutos <= 60 ? 'por-vencer' : 'acceso';
  }
  return 'vencida'; // expirado o quitado
}

/** El contador puede editar el mes con esta solicitud. */
export const puedeEditarConSolicitud = (solicitud, ahora = new Date()) =>
  ['acceso', 'por-vencer'].includes(estadoFranja(solicitud, ahora));

/** "en 58 minutos" / "en 1 minuto". */
export const textoMinutos = (n) => `en ${n} ${n === 1 ? 'minuto' : 'minutos'}`;
